import { contenuArticleMock, imageHeroMock, rubriquesBlogMock } from '@mock/schema/components';
import { pageBase } from '@mock/schema/slugs/config';
import { SlugPage } from '@pages/slug-page/models';

const blocks = [imageHeroMock, contenuArticleMock, rubriquesBlogMock];

export const blogArticleMock: SlugPage = {
  ...pageBase({
    title: 'Blog Article',
    type: 'undefined',
    language: 'fr-FR',
    headerId: 'header-fr',
    headerSubMenuId: 'menu-blog-b2c',
    footerId: 'footer-fr',
    isBreadcrumbOverlay: true,
  }),
  blocks,
};
